import { render, staticRenderFns } from "./productsprofit.vue?vue&type=template&id=bf332a62&"
import script from "./productsprofit.vue?vue&type=script&lang=js&"
export * from "./productsprofit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports